import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AppInitService } from '../../services/app-init.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-header',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {


  currentShowDropdown: boolean = false;
  showSubSubMenu: boolean = false;
  userLogin: any;
  ControlSystemsName: string | null = '';
  ControlSystemsId: string | null = '';
  menuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];
  menuTop = 0;
  menuRight = 8;
  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private appInitService: AppInitService,

  ) {


  }

  ngOnInit() {



    this.appInitService.controlSystemName$.subscribe(name => {
      this.ControlSystemsName = name;
      this.userLogin = sessionStorage.getItem('username');

    });



  }

  @ViewChild('profileMenu') profileMenu!: ElementRef;
  @ViewChild('profileButton') profileButton!: ElementRef;

  toggleDropdown() {
    this.currentShowDropdown = !this.currentShowDropdown;

    if (this.currentShowDropdown) {
      const rect = this.profileButton.nativeElement.getBoundingClientRect();
      this.menuTop = rect.bottom + 0;
      this.menuRight = window.innerWidth - rect.right;
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInsideMenu = this.profileMenu?.nativeElement.contains(event.target);
    const clickedButton = this.profileButton?.nativeElement.contains(event.target);

    if (!clickedInsideMenu && !clickedButton) {
      this.currentShowDropdown = false;
    }
  }



  logout() {

    this.authService.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    sessionStorage.clear();

  }



}



